import { VideoListV4ResponseDTO } from '@west-australian-newspapers/publication-types'
import { DataLoaderGlobalParams } from '../../data/resources'
import { httpGet } from '../../helpers/http'

export function validateGetVideosResponse(value: any): VideoListV4ResponseDTO {
    return value
}

export interface GetVideosOptions {
    series: string
}

export function getVideos(
    services: DataLoaderGlobalParams,
    options: GetVideosOptions,
) {
    return httpGet({
        log: services.log,
        validate: validateGetVideosResponse,
        baseUrl: services.config.contentApi,
        path: `v4/video`,
        customHeaders: {
            caller: services.config.apiCallerHeader,
        },
        query: {
            series: options.series,
        },
    })
}
